// eslint-disable-next-line import/extensions
import fa from './fa'
// eslint-disable-next-line import/extensions
import en from './en'

export default {
  fa,
  en,
}
